var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsbpScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 427 415",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard15",
    x: 0,
    y: 0,
    width: 426.948,
    height: 414.212,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 426.948,
    height: 414.212
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.852397,4.54747e-13,-315.335)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-10.689px",
    y: "599.945px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: "159.716px",
      fill: "#595959"
    }
  }, "DSBP")), /*#__PURE__*/React.createElement("path", {
    d: "M110.873,248.581l173.728,0",
    style: {
      fill: "none",
      stroke: "#595959",
      strokeWidth: "16.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.873,322.714l105.599,0",
    style: {
      fill: "none",
      stroke: "#595959",
      strokeWidth: "16.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.93,212.53l-0,70.884c-0,68.066 55.261,123.328 123.328,123.328l82.059,-0c68.066,-0 123.327,-55.262 123.327,-123.328l0,-70.884m-10.719,-130.335c-19.269,-43.007 -62.464,-72.999 -112.608,-72.999l-82.059,0c-50.145,0 -93.34,29.992 -112.609,72.999",
    style: {
      fill: "none",
      stroke: "#595959",
      strokeWidth: "16.67px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsbpScreen);
export default __webpack_public_path__ + "static/media/DSBPScreen.31cc9e0d230de457e45fbfa0117afdf8.svg";
export { ForwardRef as ReactComponent };